import { Form, Input } from 'antd';

export const TrophyFields = () => (
  <Form.Item name='trophy' label='Призы'>
    <Input placeholder='Кубки, медали, денежный приз' size='large'/>
  </Form.Item>
);
